<template>
  <div class="layout--full-page">
    <logout-header />
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" style="padding-top: 90px"
      id="page-login">
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
        <h1 class="mb-5 mt-5">لیست مجموعه های تحت مدیریت شما</h1>
        <div class="vx-row">
          <div v-for="provider in managedProviders" class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" :key="provider.id">
            <vx-card class="p-2">
              <vs-avatar class="mx-auto mb-6 block" size="80px" :src="provider.logo ? provider.logo.url : ''" />
              <div class="text-center">
                <h4>{{ provider.name }}</h4>
              </div>
              <div class="flex justify-center flex-wrap">
                <vs-button @click="selectProvider(provider)" class="mt-4 mr-2 shadow-lg" type="gradient" color="#7367F0"
                  gradient-color-secondary="#CE9FFC">
                  ورود به پنل
                </vs-button>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogoutHeader from "../../layouts/components/LogoutHeader.vue";

export default {
  components: { LogoutHeader },
  computed: {
    managedProviders() {
      return this.$store.state.profile.managedProviders.data;
    },
  },
  methods: {
    selectProvider(provider) {
      this.$store.dispatch("profile/SELECT_PROVIDER", provider.id);
    },
  },
  mounted() {
    if (this.managedProviders.length === 1) {
      this.selectProvider(this.managedProviders[0]);
    }
  },
};
</script>
